<div class="col-12 border-bottom pb-3" *ngIf="activity">
  <div class="row gx-3 gy-3">
    <div class="col-12 col-md-6">
      <label class="form-label small text-muted">Acción</label>
      <div>
        <span [ngSwitch]="activity.type?.toLowerCase()" class="badge-type">
          <span *ngSwitchCase="'create'" class="badge create">
            <i class="pi pi-plus-circle"></i> {{ activity.type }}
          </span>
          <span *ngSwitchCase="'read'" class="badge read">
            <i class="pi pi-eye"></i> {{ activity.type }}
          </span>
          <span *ngSwitchCase="'update'" class="badge update">
            <i class="pi pi-pencil"></i> {{ activity.type }}
          </span>
          <span *ngSwitchCase="'delete'" class="badge delete">
            <i class="pi pi-trash"></i> {{ activity.type }}
          </span>
          <span *ngSwitchCase="'login'" class="badge login">
            <i class="pi pi-sign-in"></i> {{ activity.type }}
          </span>
          <span *ngSwitchCase="'logout'" class="badge logout">
            <i class="pi pi-sign-out"></i> {{ activity.type }}
          </span>
          <span *ngSwitchDefault class="badge other">
            <i class="pi pi-question-circle"></i> Otro
          </span>
        </span>
      </div>
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label small text-muted">Tipo de sujeto</label>
      <div>{{ activity.subject_type }}</div>
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label small text-muted">Usuario</label>
      <div>{{ activity.username }}</div>
    </div>

    <div class="col-12 col-md-6">
      <label class="form-label small text-muted">IP Address</label>
      <div>{{ activity.ip_address }}</div>
    </div>
  </div>
</div>